var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterestCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#DF9F39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 26.25H15.75V24.8175C16.0575 24.8175 16.35 24.8175 16.635 24.8175C21.885 24.8175 24.255 21.7575 26.145 17.775L26.2875 18.21C26.3326 18.3646 26.4262 18.5005 26.5545 18.5978C26.6828 18.695 26.839 18.7484 27 18.75C27.0797 18.7603 27.1603 18.7603 27.24 18.75C27.3415 18.7232 27.4362 18.6753 27.518 18.6096C27.5999 18.5439 27.667 18.4617 27.7151 18.3684C27.7631 18.2751 27.7911 18.1727 27.7971 18.0679C27.8031 17.9631 27.7871 17.8582 27.75 17.76L27 15.51C26.9687 15.4163 26.9192 15.3297 26.8543 15.2552C26.7894 15.1807 26.7105 15.1197 26.6219 15.0758C26.5334 15.0319 26.4371 15.0059 26.3385 14.9993C26.24 14.9928 26.1411 15.0057 26.0475 15.0375L23.7975 15.7875C23.6036 15.8462 23.4409 15.9795 23.3452 16.1581C23.2496 16.3368 23.2288 16.5461 23.2875 16.74C23.3462 16.9339 23.4795 17.0966 23.6581 17.1923C23.8368 17.2879 24.0461 17.3087 24.24 17.25L24.87 17.04C23.01 21 20.895 23.6475 15.75 23.3025V15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25C14.8011 14.25 14.6103 14.329 14.4697 14.4697C14.329 14.6103 14.25 14.8011 14.25 15V27C14.25 27.1989 14.329 27.3897 14.4697 27.5303C14.6103 27.671 14.8011 27.75 15 27.75H27C27.1989 27.75 27.3897 27.671 27.5303 27.5303C27.671 27.3897 27.75 27.1989 27.75 27C27.75 26.8011 27.671 26.6103 27.5303 26.4697C27.3897 26.329 27.1989 26.25 27 26.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestCredit);
export default __webpack_public_path__ + "static/media/interest_credit.c71104e662036d890f655bc42d399a80.svg";
export { ForwardRef as ReactComponent };